import Blocks from '@component/Blocks';
import PageHeader from '@component/PageHeader';
import RelatedEntries from '@component/RelatedEntries';
import { getStaticPaths as utilGetStaticPaths } from '@lib/fetch/getStaticPaths';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';
import type { GetStaticPaths, GetStaticProps, NextPage } from 'next';

const ArticleView: NextPage = () => {
  return (
    <>
      <PageHeader />
      <Blocks key="blocks" />
      <RelatedEntries key="relatedEntries" />
    </>
  );
};

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('article');

export const getStaticPaths: GetStaticPaths = async () =>
  await utilGetStaticPaths({ entrySection: 'article' }, true);

export default ArticleView;
